import { UserService } from '../../services/user.service';
var AchooBarChartComponent = /** @class */ (function () {
    function AchooBarChartComponent(userService) {
        this.userService = userService;
        this.series = [];
        this.isLeftSide = true;
        this.hideRelativeCalculation = false;
        this.showValue = false;
        this.showIndex = false;
        this.isPercentValue = false;
        this.chartTitleClasses = 'default-title';
        this.startIndex = 0;
        this.isNormalLine = true;
        this.forPayingUser = false;
        this.showPlaceholder = false;
        this.progressHeight = 13;
        this.borderRadius = 13;
    }
    AchooBarChartComponent.prototype.ngOnInit = function () {
        if (!this.isNormalLine) {
            this.progressHeight = 27;
            this.borderRadius = 27;
        }
        if (this.maxLine) {
            this.series = this.series.slice(0, this.maxLine);
        }
    };
    AchooBarChartComponent.prototype.calculateProgress = function (value) {
        if (this.isPercentValue) {
            return value;
        }
        if (this.series.length === 0) {
            return 0;
        }
        var totalValue = this.series.map(function (s) { return s.value; }).reduce(function (a, b) { return a + b; });
        return Math.round((value / totalValue) * 100);
    };
    Object.defineProperty(AchooBarChartComponent.prototype, "chartColor", {
        get: function () {
            return this.chartBgColor ? this.chartBgColor : this.userService.chartColors[6];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AchooBarChartComponent.prototype, "canShowChart", {
        get: function () {
            if (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin) {
                return false;
            }
            return !this.showPlaceholder;
        },
        enumerable: true,
        configurable: true
    });
    return AchooBarChartComponent;
}());
export { AchooBarChartComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-bar-chart/achoo-bar-chart.component.ts.pre-build-optimizer.js